export const customCardData = {
	customCardContent: '',
};
